import api from "./axiosInstance";
import { baseURL, createHeaders } from "./constants";

const contactUs = async (payload) => {
  try {
    return api.post(`${baseURL}/contact-uses`, { data: { ...payload }}, {headers: createHeaders()},);
  } catch (error) {
    throw error;
  }
};
export { contactUs };
